module.exports = __webpack_public_path__ + "img/system46.7156abd6.png";